<template>
  <v-card flat height="calc(100vh - 106px)" class="overflow-y pt-4 pl-4">
    <v-container fluid>
      <v-row>
        <v-col>PŪRTRAK products and items are mapped to Square products by SKU.</v-col>
      </v-row>
      <v-row align="center">
        <v-col cols="6" sm="3" lg="2">
          <v-select v-model="productView" :items="['Purtrak','Square']" label="Map from" outlined dense hide-details/>
        </v-col>
        <v-col cols="12" sm="9" class="text-caption">
          <template v-if="productView==='Purtrak'">
            Selecting a Square product for a PŪRTRAK product/item sets the PŪRTRAK SKU.
          </template>
          <template v-else>
            Selecting a PŪRTRAK product/item sets the Square product SKU.
          </template>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card flat outlined>
            <v-data-table v-if="productView==='Purtrak'" class="no-sort"
                          calculate-widths disable-filtering disable-pagination disable-sort hide-default-footer
                          :items="products"
                          :headers="[{text:'Type',value:'type',width:'10%'},
                                    {text:'Name',value:'name',width:'40%'},
                                    {text:'SKU',value:'sku',width:'10%'},
                                    {text:'Square product: variant',value:'square',width:'40%'}]">
              <template v-slot:item.sku="{item}">
                <template v-if="item.sku">{{item.sku}}</template>
                <v-chip v-else small color="warning">Undefined</v-chip>
              </template>
              <template v-slot:item.square="{item}">
                <v-select :items="squareProducts" hide-details class="text-body-2 pt-0 mt-0" v-model="item.squareId"
                          placeholder="No Square product with matching SKU"
                          @change="setProductSKU(item)" clearable @click:clear="clearProductSKU(item)">
                  <template v-slot:selection="{item}">
                    {{item.parent}}: {{item.text}}
                  </template>
                  <template v-slot:prepend-item v-if="!item.squareId">
                    <div class="pa-4 grey lighten-3 text-body-2 cursor-pointer"
                        @click="product={...item,addSKU:item.sku==='',parent:topLevelSquare[0].value,addVariant:false};showAddToSquare=true">
                      Add product to Square
                    </div>
                  </template>
                  <template v-slot:item="{item}">
                    <v-list-item-content class="text-body-2" :class="{'pl-4':item.indent}">
                      {{item.text}}
                      <v-list-item-subtitle v-if="item.disabled" class="text-caption">Square product missing SKU</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action class="text-caption">{{item.sku}}</v-list-item-action>
                  </template>
                </v-select>
              </template>
            </v-data-table>
            <v-data-table v-else class="no-sort"
                          calculate-widths disable-filtering disable-pagination disable-sort hide-default-footer
                          :items="squareProducts"
                          :headers="[{text:'Product',value:'name',width:'40%'},
                                    {text:'SKU',value:'sku',width:'10%'},
                                    {text:'PURTRAK product/item (with a SKU)',value:'pt',width:'50%'}
                                    ]">
              <template v-slot:item.name="{item}">
                <span :class="{'ml-6':item.indent}">{{item.header || item.text}}</span>
              </template>
              <template v-slot:item.sku="{item}">
                <template v-if="item.sku">
                  {{item.sku}}
                </template>
                <v-chip v-else-if="!item.header" small color="warning">Undefined</v-chip>
              </template>
              <template v-slot:item.pt="{item}">
                <v-select v-if="!item.header" :items="productsWithSKU" item-text="name" item-value="sku" hide-details class="text-body-2 pt-0 mt-0" v-model="item.sku"
                          placeholder="No PURTRAK product with matching SKU"
                          @change="setSquareSKU(item)" clearable @click:clear="setSquareKU(item, true)">
                  <template v-slot:item="{item}">
                    <v-list-item-content class="text-body-2">
                      {{item.name}}
                      <v-list-item-subtitle v-if="item.sku===''" class="text-caption">Missing SKU</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action class="text-caption">{{item.sku}}</v-list-item-action>
                  </template>
                </v-select>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="showAddToSquare" persistent max-width="500">
      <v-card>
        <v-card-title>Add to Square</v-card-title>
        <v-divider/>
        <v-card-text class="pt-4">
          <v-container>
            <v-row>
              <v-col class="text-body-1">Adding <strong>{{product.name}}</strong></v-col>
            </v-row>
            <v-row v-if="product.addSKU">
              <v-col cols="8" md="6"><v-text-field v-model="product.sku" label="SKU" outlined dense :error-messages="product.sku ? '' : 'Required'"/></v-col>
            </v-row>
            <v-row align="center" dense v-if="topLevelSquare.length">
              <v-col cols="8" md="4"><v-checkbox v-model="product.addVariant" label="Add as variant"/></v-col>
              <v-col cols="12" md="8"><v-select outlined dense hide-details :items="topLevelSquare" :disabled="!product.addVariant" v-model="product.parent"></v-select></v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer></v-spacer>
          <v-btn color="primary" plain @click="showAddToSquare=false">Cancel</v-btn>
          <v-btn color="primary" @click="addToSquare" :disabled="!product.sku" :loading="loading">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-card>
</template>

<script>
export default {
  name: 'AppsSquareProducts',
  props: {
    square: {type:Object, required:false}
  },
  data() {
    return {
      productView: 'Purtrak',
      products: [],
      squareProducts: [],
      topLevelSquare: [],
      product: {},
      showAddToSquare: false,
      loading: false
    }
  },
  computed: {
    productsWithSKU() {
      return this.products.filter(product => product.sku);
    }
  },
  async created() {
    const bundles = [];
    const data = await Promise.all([
      this.$store.dispatch('products'),
      this.$store.dispatch('items'),
      this.$lazyListLoad(bundles, 'bundles2', 'id,name,sku', 100, [{field:'active', comparator:'eq', value:'true'}]),
    ]);
    this.products = [...data[0].filter(product => product.active).map(product => ({...product,type:'Product'})),
                     ...data[1].filter(item => item.active).map(item => ({...item,type:'Item'})),
                     ...bundles.map(item => ({...item,type:'Bundle'}))
                    ];
    this.buildSquareProducts();
  },
  methods: {
    buildSquareProducts() {
      // Build flat array of Square products for v-select and top level products only
      this.squareProducts = [];
      this.topLevelSquare = [];
      for (const product of this.square.products) {
        this.topLevelSquare.push({text:product.productName,value:product.id});
        this.squareProducts.push({header:product.productName});
        for (const variant of product.variants) {
          const sku = variant.sku;
          this.squareProducts.push({text:variant.variantName,sku,disabled:!sku,value:variant.id,parent:product.productName,indent:true});
        }
      }

      // Set PT products to reference Square product
      for (const product of this.products) {
        const id = this.findSquareProductId(product.sku);
        this.$set(product, 'squareId', id);
      }
    },
    findSquareProductId(sku) {
      if (!sku)
        return null;
      for (const sProduct of this.square.products) {
        const variant = sProduct.variants.find(variant => variant.sku === sku);
        if (variant)
          return variant.id;
      }
      return null;
    },
    async setProductSKU(product) {
      let sku;
      for (const sProduct of this.square.products) {
        const variant = sProduct.variants.find(variant => variant.id === product.squareId);
        if (variant) {
          sku = variant.sku;
          break;
        }
      }
      if (!sku)
        product.squareId = null;
      else {
        const results = await this.$apiCall(`mutation AppsSquareProducts($id: ID!, $sku:String!, $isProduct:Boolean!, $isItem:Boolean!, $isBundle:Boolean!) {
                                              productSetSKU(id:$id,sku:$sku) @include(if:$isProduct) {sku}
                                              itemSetSKU(id:$id,sku:$sku) @include(if:$isItem) {sku}
                                              bundleSetSKU(id:$id,sku:$sku) @include(if:$isBundle) {sku}
                                            }`,
                                            {id:product.id,sku,
                                             isProduct:product.type==='Product',
                                             isItem:product.type==='Item',
                                             isBundle:product.type==='Bundle'});
        if (!results.error) {
          if (product.type === 'Product') {
            product.sku = results.data.productSetSKU.sku;
            this.$store.commit('productUpdate', {...product, sku:results.data.productSetSKU.sku});
          }
          else if (product.type === 'Item') {
            product.sku = results.data.itemSetSKU.sku;
            this.$store.commit('itemUpdate', {...product, sku:results.data.itemSetSKU.sku});
          }
          else if (product.type === 'Bundle')
            product.sku = results.data.bundleSetSKU.sku;
        }
        else
          product.squareId = this.findSquareProductId(product.sku);
      }
    },
    async clearProductSKU(product) {
      const results = await this.$apiCall(`mutation AppsSquareProducts($id: ID!, $isProduct:Boolean!, $isItem:Boolean!, $isBundle:Boolean!) {
                                            productSetSKU(id:$id,sku:"") @include(if:$isProduct) {sku}
                                            itemSetSKU(id:$id,sku:"") @include(if:$isItem) {sku}
                                            bundleSetSKU(id:$id,sku:"") @include(if:$isBundle) {sku}
                                          }`,
                                            {id:product.id,
                                             isProduct:product.type==='Product',
                                             isItem:product.type==='Item',
                                             isBundle:product.type==='Bundle'});
      if (!results.error) {
        if (product.type === 'Product')
          product.sku = results.data.productSetSKU.sku;
        else if (product.type === 'Item')
          product.sku = results.data.itemSetSKU.sku;
        else if (product.type === 'Bundle')
          product.sku = results.data.bundleSetSKU.sku;
        product.squareId = null;
      }
    },
    async setSquareSKU(product, clear=false) {
      if (product.sku == null)
        return;
      this.loading = true;
      const results = await this.$apiCall(`mutation AppsSquareProducts($id: String!, $sku:String!) {
                                            squareSetVariantSKU(id:$id,sku:$sku)
                                          }`,
                                          {id:product.value,sku:clear ? '' : product.sku}, false, 'square');
      this.loading = false;
      if (!results.error)
        product.sku = results.data.squareSetVariantSKU;
    },
    async addToSquare() {
      this.loading = true;
      const product = this.products.find(p => p.id === this.product.id);

      if (this.product.addSKU) {


        const results = await this.$apiCall(`mutation AppsSquareProducts($id: ID!, $sku:String!, $isProduct:Boolean!, $isItem:Boolean!, $isBundle:Boolean!) {
                                              productSetSKU(id:$id,sku:$sku) @include(if:$isProduct) {sku}
                                              itemSetSKU(id:$id,sku:$sku) @include(if:$isItem) {sku}
                                              bundleSetSKU(id:$id,sku:$sku) @include(if:$isBundle) {sku}
                                            }`,
                                            {id:this.product.id,sku:this.product.sku,
                                             isProduct:this.product.type==='Product',
                                             isItem:this.product.type==='Item',
                                             isBundle:this.product.type==='Bundle'});
        if (results.error) {
          this.loading = false;
          return;
        }
        if (product.type === 'Product')
          this.product.sku = results.data.productSetSKU.sku;
        else if (product.type === 'Item')
          this.product.sku = results.data.itemSetSKU.sku;
        else if (product.type === 'Bundle')
          this.product.sku = results.data.bundleSetSKU.sku;
        product.squareId = null;
        product.sku = this.product.sku;
      }

      if (this.product.sku) {
        const results = await this.$apiCall(`mutation AppsSquareProducts($id: ID!, $parent:String) {
                                              squareAddProduct(id:$id,parent:$parent) {
                                                id,productName,variants {id,variantName,sku}
                                              }
                                            }`,
                                            {id:this.product.id, parent:this.product.addVariant?this.product.parent:null}, false, 'square');
        if (!results.error) {
          this.square.products = results.data.squareAddProduct;
          this.buildSquareProducts();
          product.squareId = this.findSquareProductId(this.product.sku);
          this.showAddToSquare = false;
          this.$store.commit('setError', {type:'success',message:`${this.product.name} added to Square. You should check all settings for the product on Square.`});
        }
      }
      this.loading = false;
    }
  }
}
</script>